import React, { useState, ChangeEvent } from "react";

import MaterialUISwitch from "@material-ui/core/Switch";

export default function Switch({
  value,
  onChange
}: {
  value: boolean;
  onChange: (checked: boolean) => void;
}) {
  const [checked, onSwitchChange] = useState(value);

  return (
    <MaterialUISwitch
      checked={checked}
      onChange={(event: ChangeEvent<HTMLInputElement>) => {
        const { checked } = event.target;

        onChange(checked);
        onSwitchChange(checked);
      }}
      value={true}
    />
  );
}
